import Swiper, { A11y, Keyboard, Navigation, Pagination } from 'swiper';

import '../../sass/blocks/gallery.scss';

( () => {
    const $galleries = document.querySelectorAll('.gallery');

    if ( !$galleries ) return;

    $galleries.forEach( $gallery => {
        const $slider = $gallery.querySelector('.gallery__slider');

        const initSlider = () => {
            if ( !$slider ) return;

            const $previous = $gallery.querySelector('.gallery__slider-previous');
            const $next = $gallery.querySelector('.gallery__slider-next');
            const $pagination = $gallery.querySelector('.gallery__slider-pagination');

            const slider = new Swiper($slider, {
                modules: [ A11y, Keyboard, Navigation, Pagination ],
                loop: true,
                a11y: {},
                keyboard: {
                    enabled: true,
                    onlyInViewport: false
                },
                navigation: $next && $previous ? {
                    nextEl: $next,
                    prevEl: $previous
                } : false,
                pagination: {
                    el: $pagination,
                    clickable: true
                },
            });
        };

        initSlider();
    } );
} )();
